module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question1.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question1.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question2.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question2.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question2.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question3.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0",
				"water-type_opt1",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0"
							]
						}
					]
				},
				{
					"text": "question3.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0"
							]
						}
					]
				},
				{
					"text": "question3.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"water-type_opt0"
							]
						}
					]
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout",
				"water-type_opt1 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0"
					]
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && finish",
				"water-type_opt0 && duo-spout && finish",
				"water-type_opt0 && finish",
				"main-faucet && finish",
				"main-faucet && !duo-spout_opt0 && finish",
				"water-type_opt0 && duo-spout_opt2",
				"water-type_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!(main-faucet_opt0 && duo-spout_opt0)"
					]
				}
			]
		}
	],
	"conditions": []
};


//////////////////
// WEBPACK FOOTER
// ./src/data/water_questions_tr_tr.json
// module id = 908
// module chunks = 0